import installer from "./en/installer"
import ambassadors from "./en/ambassadors"
import career from "./en/career"
import about from "./en/about"
export default {
  installer,
  ambassadors,
  career,
  about,
  navigation: {
    installers: "Installers",
    blog: "Blog",
    help: "Help",
    "about-us": "About us",
    "sign-in": "Sign in",
    "sign-up": "Sign up",
  },

  footer: {
    "products-for-installers": "Products for installers",
    "find-clients": "Find clients",
    administration: "Administration",
    "digital-sales-tools": "Digital sales tools",
    resources: "Resources",
    documentation: "Documentation",
    guide: "Guide",
    blog: "Blog",
    "support-centre": "Support Center",
    partners: "Partners",
    enterprise: "Company",
    home: "Home",
    "about-us": "About us",
    "company-values": "Company Values",
    pricing: "Pricing",
    newsletter: "Subscribe",
    "subscribe-newsletter":
      "Get the latest news and articles to your inbox every month",
    "your-email": "Your email",
    copyright: "2023 © projetsolaire.com. All rights reserved.",
    "terms-and-conditions": "Terms",
    "privacy-policy": "Privacy Policy",
    "contact-us": "Contact",
    press: "Presse",
    technology: "Technologie",
  },

  "reset-password": {
    title: "Recover your password",
    subtitle:
      "Entrez l'adresse email que vous avez utilisée lors de votre inscription, et nous vous enverrons un email automatique pour vous réinitialiser votre mot de passe.",
    "check-your-inbox": "vérifiez votre boîte de réception",
    type: {
      householder: "Householder",
      installer: "Installer",
    },
    success: {
      title: "vérifiez votre boîte de réception",
      description: "",
    },
    callback: {
      title: "réinitialiser votre mot de passe",
      "description-1":
        "« Pour protéger vos informations, il est nécessaire de choisir et d’utiliser des mots de passe robustes, c’est-à-dire difficiles à retrouver à l’aide d’outils automatisés et à deviner par une tierce personne »",
      "description-2": "www.interieur.gouv.fr",
      anssi: "l’Agence Nationale de la Sécurité des Systèmes d’Information",
      password: "Password",
      "confirm-password": "Confirm password",
      "reset-your-pass-word": "Reset password",
    },
    "forgot-password": {
      title: "Forgot your password ?",
      description:
        "Enter the email address you used when you registered your account, and we will send you a secure password reset email.",
      "select-type": "You are ...",
      email: "Email",
      "reset-your-pass-word": "Reset password",
    },
  },

  "sign-in": {
    title: "Welcome Back! ",
    "type-select": "You are ...",
    "having-trouble": "Having trouble signing in?",
    "keep-me-signed-in": "Keep me signed in",
    "dont-have-an-account": "Don't you have an account? ",
    type: {
      householder: "Householder",
      installer: "Installer",
    },
    errors: {
      "account.locked":
        "”You've tried to log in too many times without success. For security reasons, your account is locked for 15 minutes. Please wait or reset your password if needed. ",
    },
  },

  "sign-up": {
    title:
      "Welcome. Start your <span class='bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-yellow-400'>solar</span> journey today.",
    tc: " By creating an account, you agree to the <a class='underline' href='/help/guides/installers/legal/declaration-de-confidentialite'>terms & conditions</a>, and our <a class='underline' href='/help/guides/installers/legal/declaration-de-confidentialite'>privacy policy</a>.",
    "already-registered": "Already using Projetsolaire?",
    "company-name": "Votre raison sociale",
    "enter-your-company-name": "Entrez votre raison sociale",
    "password-confirm": "Confirmez votre mot de passe",
    type: {
      householder: "Householder",
      installer: "Installer",
    },
    success: {
      title:
        "Bienvenue ! Veuillez consulter votre courrier électronique avant d'accéder au service élance.",
      description:
        'Veuillez consulter votre boîte mail afin de confirmer la création de votre compte. Si vous ne voyez pas l\'email de confirmation tout de suite, veuillez vérifier votre dossier "spam" ou "courrier indésirable" et marquez-le "non-spam". Le message de confirmation s\'y retrouve parfois par erreur. Si vous avez une question n\'hésitez pas à nous contacter par courrier électronique.',
    },
    callback: {
      success: {
        title: "Inscription réussie",
        description: "L'email de votre compte a été validé avec succès",
      },
      invites: {
        installer: {
          title: "Vous êtes invité pour rejoindre votre équipe solaire",
          description:
            "Veuillez confirmer l’invitation pour créer votre compte à vous et obtenir l’accès à l’espace professionnel en ligne.",
        },
        user: {
          title: "",
          description: "",
        },
        lead: {
          title: "",
          description: "",
        },
      },
    },
    password: {
      required: "The password is required",
      "min-length": "The password must contain at least 8 characters",
      "upper-case": "The password must contain at least one uppercase letter",
      "lower-case": "The password must contain at least one lowercase letter",
      symbol:
        "The password must contain at least one special character ($!%*?&)",
      number: "The password must contain at least one number",
    },
    "phone-number": {
      label: "Phone number",
      placeholder: "0-00-00-00-00",
    },
    invite: {
      title: "Congratulations, your establishment already has an account!",
      description:
        "The SIRET {siret} of the company is already registered with projetsolaire.",
      button: "Log in",
    },
  },

  home: {
    hero: {
      "find-an-installer": "Find an installer",
      "i-am-installer": "I'm an installer",
      title:
        "Helping France go <span class='bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-yellow-400'>solar</span>",
      subtitle:
        "The easiest way to go solar, from discovering your solar potential to installation day.",
      "learn-more": "Learn more",
      "discover-potential": "Discover your solar potential",
      "watch-video": "Watch the full video (30s)",
    },

    "how-to": {
      title: "How to go solar?",
      description:
        "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur excepteur sint occaecat cupidatat.",
    },

    "why-us": {
      title: "Pourquoi passer au solaire avec nous ?",
      description:
        "Nous vous encadrons la réalisation de votre projet solaire. Notre plateforme communautaire repose sur des principes simples : transparence des offres des maitres d'œuvres, parcours à votre rythme, sans engagements. Le service est gratuit pour les particuliers.",
      features: {
        model: {
          title: "Get a in-depth customised solar model",
          description:
            "We take your real historic consumption data from the grid and combine that with an estimate of your solar production using Lidar to produce a 25 year financial model of your own solar project.",
        },
        installers: {
          title: "Get quotes from trusted installers",
          description:
            "We have a network of installers ready to quote on your project. Benefit from a wide range of options and achieve a better price",
        },
        administration: {
          title: "Take care of your administration",
          description:
            "Let us take care of all your administration as part of the solar installation journey. Track its progress online or on your mobile.",
        },
        support: {
          title: "Support all the way until installation day",
          description:
            "Any questions during your installation journey? We are here for you, we have a dedicated staff ready to answer any questions you may have",
        },
      },
    },
    stats: {
      "our-track-record": "Our track record",
      title: "Weve helped homes all across France go solar",
      description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis suscipit eaque, iste dolor cupiditate blanditiis ratione.",
      "stats-value": {
        "3-quotes-guarantee": {
          title: "Entreprises par appel d'offres, moyenne",
          value: "4 propositions",
        },
        "installers-in-network": {
          title: "Installateurs photovoltaïques chez nous",
          value: "100 +",
        },
        "cost-reduction": {
          title: "Réduction sur montant du devis, moyenne",
          value: "40 %",
        },
        "aided-solar-projects": {
          title: "Projets solaires rendus possible",
          value: "3 000 +",
        },
      },
    },

    stories: {
      title: "Discover others solar journey",
      description:
        "Meet our community of households who have gone solar all across france Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum ",
      button: "Discover all stories",
    },

    community: {
      title: "Join our community of solar projects",
      description:
        "We have helped people go solar all across France. Start your solar journey today and join the rest of France on the national solar mission",
    },
    mission: {
      title: "Our mission",
      paragraph1:
        "Our objective is to facilitate, secure and then democratize at scale all the stages of the photovoltaic installation.",
      paragraph2: "Make it easier to go solar",
      paragraph3: "End scams",
      paragraph4: "Massively increase the number of solar installations",
      paragraph5:
        "Projetsolaire.com is therefore the solar project of a family, a local business, a community … it is their solar project, it is her solar project. This is finally your solar project too.",
    },

    cta: {
      title: "Want to discover more?",
      subtitle: "Please book a call on our current site Maison Elance.",
      benefit: {
        benefit1: "Competitive salaries",
        benefit2: "Flexible work hours",
        benefit3: "30 days of paid vacation",
        benefit4: "Annual team retreats",
        benefit5: "Benefits for you and your family",
        benefit6: "A great work environment",
      },
      button: "Discover more",
    },
  },

  blog: {
    hero: {
      title: "Start learning solar",
      subtitle:
        "Discover how to go solar and read up on other peoples solar journeys.",
    },
    "installation-steps": {
      title: "How to go solar in France?",
      subtitle:
        "Below are the tutorials outlining how to go solar in France. All these steps can be completed online and get you a trusted installer with a competitive price.",
    },
    featured: {
      title: "Main articles",
      subtitle: "Browse through some of our most read articles.",
    },
    latest: {
      title: "New articles",
      subtitle:
        "Stay up to date on the latest articles from our independent editorial team.",
      by: "written by ",
    },
    series: {
      topics: "Topics",
      "topics-series": {
        stories: "Stories",
        "why-go-solar": "Why go solar",
        "how-to-go-solar": "How to go solar in France ?",
      },
    },
    popular: {
      "popular-on": "Popular on Projetsolaire",
      by: "By ",
    },
  },

  about: {
    "mission-statement":
      "<span class='opacity-50'>Our</span> mission <span class='opacity-50'>is</span><br /> to solve residential solar <br /> in France",
    intro: {
      title: "We enable solar projects to happen",
      description:
        "Our aim is to transform solar project installation, making it faster, cheaper, simpler... better!",
    },
    story: {
      title: "Our journey",
      "paragraph-1": ".",
      "paragraph-2": "",
      "paragraph-3": "",
      "paragraph-4": "",
      "paragraph-5": "",
      "paragraph-6":
        "Implantée en Provence, notre startup innovante compte trois cofondateurs-associés. À ce jour, nous n’avons jamais eu besoin de lever de l’argent ni de dépenser un seul euro en publicité. Au contraire, notre méthode c’est la satisfaction client et le bouche-à-oreille.",
      "paragraph-7": "",
      "paragraph-8": "",
    },
    stats: {
      title: "Acteur de l’indépendance énergétique de France.",
      description:
        "Notre plateforme communautaire réunit tous les porteurs de projets solaires avec les professionnels du photovoltaïque ; ensemble avec tous les acteurs de la transition énergétique - bureaux d’études, fournisseurs, financiers, municipalités, services publics.",
      "flagship-projects":
        "Nous nous sommes élancé dans le solaire lors du premier confinement.",
      "installers-on-our-platform":
        "Artisans sur notre plateforme communautaire.",
      "solar-projects-enabled": "Projets solaires propulsés.",
      followers: "Followers",
    },
    team: {
      header: {
        badge: "Our team",
        title: "The team behind the technology",
        description: "We're a dynamic group of individuals who are passionate about what we do and dedicated to delivering the best results for our clients."
      },
      title: "L'équipe derrière la technologie",
      description:
        "We're a dynamic group of individuals who are passionate about what we do and dedicated to delivering the best results for our clients.",
      people: {
        "person-1": {
          name: "Yann",
          role: "Operations lead & Co-founder",
          bio: "Yann Vermeil Schremmer continue d'imaginer de nouveaux modes de fonctionnement en interne, puis coordonne les divers interlocuteurs externes pour allier au mieux l’entreprenariat avec l’environnement.",
        },
        "person-2": {
          name: "Maarten",
          role: "CTO & Co-founder",
          bio: "Maarten Elgar développe la technologie qui aide les foyers à se mettre à l'énergie solaire en leur permettant d'obtenir des devis d'installateurs de confiance, puis de faire réaliser le reste du parcours en ligne.",
        },
        "person-3": {
          name: "Georges",
          role: "Sales lead & Co-founder",
          bio: "Georges Séraphim-André Nevsky aide les françaises et de français à découvrir leur potentiel solaire puis définir leur projet sur-mesure. Il aide les artisans photovoltaïques à bénéficier des nouvelles technologies de pointe.",
        },
        "person-4": {
          name: "Aurélie",
          role: "Head of administration",
          bio: "Aurélie Aparicio accompagne les professionnels dans leurs démarches technico-administratives de conformité, en apportant sécurité et toute l’aide aux citoyens voulant passer par la bureautique de l'énergie solaire..",
        },
        "person-5": {
          name: "Kelly",
          role: "Head of Design & Junior Developer",
          bio: "Aurélie Aparicio accompagne les professionnels dans leurs démarches technico-administratives de conformité, en apportant sécurité et toute l’aide aux citoyens voulant passer par la bureautique de l'énergie solaire..",
        },
        "person-6": {
          name: "Sebastian",
          role: "Front-end Engineer",
          bio: "Aurélie Aparicio accompagne les professionnels dans leurs démarches technico-administratives de conformité, en apportant sécurité et toute l’aide aux citoyens voulant passer par la bureautique de l'énergie solaire..",
        },
      },
    },
  },

  career: {
    navigation: {
      directory: "Annuaire Artisans RGE",
      ambassadors: "Ambassadors",
      careers: "Careers",
      blog: "Blog",
      about: "About us",
      product: "Product",
      menu: "Menu",
    },
    title: "Projetsolaire is growing. Grow with us.",
    description:
      "We are based in Marseille and looking for people to join our passionate team. Interested in working in renewable energy and helping people go solar? Join us now",
    home: {
      title: "Want to do something <br /> great?",
      description:
        "Join us to help everyone everywhere access solar energy - clean, free and independent.",
      mission: {
        label: "Fighting climate injustice",
        title: "Our mission"
      }
    },
    openings: {
      title: "Current open positions",
      "fullstack-engineer": "Senior fullstack engineer",
      "junior-frontend-engineer": "Junior frontend engineer",
      "junior-account-representative": "Junior account representative",
      "account-representative": "Senior account representative",
      "job-openings": "Job openings",
      role: "Role",
      description: "Description",
      salary: "Salary",
      location: "Location",
      "view-all-openings": "View all openings",
    },
    process: {
      "step-1": {
        title: "Apply",
        description:
          "Duis aute irure dolor in reprehenderitin volupta velit esse cillum sint occaecat cupidatat.",
      },
      "step-2": {
        title: "Screening",
        description:
          "Duis aute irure dolor in reprehenderitin volupta velit esse cillum sint occaecat cupidatat.",
      },
      "step-3": {
        title: "Interview",
        description:
          "Duis aute irure dolor in reprehenderitin volupta velit esse cillum sint occaecat cupidatat.",
      },
      "step-4": {
        title: "Job Offer",
        description:
          "Duis aute irure dolor in reprehenderitin volupta velit esse cillum sint occaecat cupidatat.",
      },
    },
    cta: {
      text: "Sounds like we are building something cool?",
      button: "Join us today",
    },
    stats: {
      title: "Accelerating the solar <br /> revolution",
      description1: "For the first time since the industrial revolution, citizens can produce their own energy. We are building the best tech in the world for a bright future in the face of climate urgency.",
      description2: "We embarked on solar as soon as we understood how difficult it is for our parents to become self-sufficient in clean energy, despite the tremendous progress in photovoltaic technologies.",
      stat1: {
        value: "+122 MW",
        label: "of solar projects"
      },
      stat2: {
        value: "+8000",
        label: "solar projects"
      },
      stat3: {
        value: "+1000",
        label: "professionals"
      }
    },
    coreValues: {
      value1: {
        title: "Customer first",
        description: "The operational excellence of our teams at the best price for our customers is non-negotiable."
      },
      value2: {
        title: "Full speed ahead",
        description: "We develop rapidly. We respond instantly. We act without delay. Acting is now."
      },
      value3: {
        title: "Team play",
        description: "We are a small, tight-knit team. Our benevolent pragmatism is the magic recipe for our collective strength."
      }
    },
    quote: {
      text: "They can because they think they can.",
      attribution: "Virgil - Aeneid, Book 5"
    },
    growth: {
      title: "Our projetsolaire is growing.<br /> Grow with us.",
      description: "Based in Provence, we are looking for talents to flourish and prosper. Want to have an impact on the climate by helping our fellow citizens make the solar revolution? Welcome!",
      button: "View open positions"
    },
    apply: {
      title: "Apply for position",
      subtitle:
        "Tell us about you ! Complete the form below to submit your application.",
    },
    commitments: {
      FULL_TIME: "Full time",
      PART_TIME: "Part time",
      INTERNSHIP: "Internship",
      CONTRACT: "Contract",
      COFOUNDER: "Director",
    },
    roles: {
      COFOUNDER: "Director",
      PROGRAMMING: "Programming",
      CONTRACT: "Self-employed",
      DESIGN: "Design",
      MANAGEMENT: "Management",
      BUSINESS_DEVELOPMENT: "Business development",
      SALES_AND_MARKETING: "Sales and marketing",
      ADMINISTRATION: "Administration",
      OPERATIONS: "Operations",
      SERVICE_CLIENT: "Service Client",
    },
    roleDescriptions: {
      COFOUNDER: "Director role description",
      PROGRAMMING: "Programming role description",
      CONTRACT: "Contract role description",
      DESIGN: "Design role description",
      MANAGEMENT: "Management role description",
      BUSINESS_DEVELOPMENT: "Business development role description",
      SALES_AND_MARKETING: "Sales and marketing role description",
      ADMINISTRATION: "Administration role description",
      OPERATIONS: "Operations role description",
      SERVICE_CLIENT: "Service client role description",
    },
    post2: {
      intro: {
        label: "Careers at projetsolaire",
        title: {
          colored: "Join us",
          rest: " to make an impact on solar energy.",
        },
        description:
          "We are building the future of clean, decentralized energy in the south of France, surrounded by some of the most beautiful landscapes in the world.",
      },
      opportunities: {
        title: "Available Opportunities",
        description: "We care little about formal education. We are simply looking for people capable of building their future autonomously.",
      },
      operation: {
        title: "Operations",
        description: "Open positions in our operations department",
        job: {
          title: "Account Integration Manager",
          description:
            "More and more professionals want our solutions. Help us support photovoltaic and storage installers.",
          type: "Self-employed",
          role: "Sales",
          location: "Marseille, France",
        },
      },
      service: {
        title: "Customer Service",
        description: "Open positions in our customer service department",
        job: {
          title: "Customer Service Manager",
          description:
            "We are looking for an extremely talented and efficient person to support our growth efforts in France.",
          type: "Full time",
          role: "Business Developer",
          location: "Marseille, France",
        },
      },
      apply: "Apply",
    },
  },

  "dynamic-forms": {
    leads: {
      heading: {
        title: "Bonjour {fullName}!",
        subtitle:
          "Pour nous aider à modéliser le potentiel solaire de votre maison, nous avons besoin de quelques informations. Cela ne vous prendra que quelques minutes !",
      },
      "verifying-token": "Vérification de votre accès",
      submitted: "Vous avez partagez vos informations avec succès !",
      steps: {
        "customer-information": {
          title: "Vos informations personnelles",
          subtitle: "Confirmer vos informations personnelles",
        },
        address: {
          title: "Votre adresse",
          subtitle: "Confirmer votre adresse",
        },
        "electricity-bill": {
          title: "Votre facture d électricité",
          subtitle: "Télécharger votre facture d'électricité",
          "paragraph-1":
            "Pour pouvoir modéliser votre maison avec précision, nous avons besoin de votre facture d'électricité. Cela nous aide à projeter vos rendements avec votre contrat d'électricité réel.",
        },
        confirm: {
          title: "Envoyez vos informations",
          subtitle:
            "Une fois que vous êtes satisfait, soumettez vos informations pour votre modèle personnalisé",
          "paragraph-1":
            "Si vous êtes satisfait de vos informations, cliquez sur 'Envoyer' et nous commencerons à préparer votre modèle personnalisé dans les 48 heures.</br>",
        },
      },

      errors: {
        "token-invalid": "L'accès est invalide",
        "token-missing": "L'accès est invalide",
      },
    },
    administration: {
      heading: {
        title: "Bonjour {fullName}!",
        subtitle:
          "Pour compléter vos services, nous avons besoin de quelques informations. Cela ne vous prendra que quelques minutes à remplir !",
        "subtitle-for-installer":
          "Pour compléter les services de {customerName} au {fullAddress}, nous avons besoin des informations suivantes. Cela ne vous prendra que qu'une seule minute à remplir !",
      },

      submitted: "Vous avez partagez vos informations avec succès !",
      "verifying-token": "Vérification de votre accès",
      steps: {
        "customer-information": {
          title: "Vos informations personnelles",
          subtitle: "Confirmer vos informations personnelles",
        },
        address: {
          title: "Votre adresse",
          subtitle: "Confirmer votre adresse",
        },
        documents: {
          title: "Documents",
          subtitle:
            "Télécharger le document demandé pour compéter votre services",
          "paragraph-1":
            "Pour pouvoir modéliser votre maison avec précision, nous avons besoin de votre facture d'électricité. Cela nous aide à projeter vos rendements avec votre contrat d'électricité réel.",
          "property-deed": "titre de propriété",
          "mayor-approval": "Permitting approval",
          "electricity-bill": "facture électrique",
          "consuel-approval": "AC du Consuel",
          "manual-mayor-single-mandate":
            "Signature du mandat spécial de représentation - Autorisation d’urbanisme",
          "manual-enedis-single-mandate":
            "Signature du mandat spécial de représentation - Demande de raccordement",
          "wiring-diagram": "Schéma électrique unifilaire",

          esign: {
            "mayor-single-mandate":
              "Signature du mandat spécial de représentation - Autorisation d’urbanisme",
            "enedis-single-mandate":
              "Signature du mandat spécial de représentation - Demande de raccordement",
            "dual-mandate": "Signature du mandat spécial de représentation",
          },
        },
        hardware: {
          title: "Matériel",
          subtitle: "Ajouter l'inventaire avec lequel le système est installé",
          panelLayoutDescription: "Description du calepinage",
          panel: "Panneaux",
          inverter: "Onduleur",
        },
        technicals: {
          title: "Technicals",
          subtitle: "Ajouter les informations techniques de l'installation",
          "paragraph-1":
            "Si vous êtes satisfait de vos informations, cliquez sur 'Envoyer' et nous commencerons à préparer votre modèle personnalisé dans les 48 heures.</br>",
          "system-size": "puissance de l’installation solaire (kVa)",
          "usage-point": "numéro du Point De Livraison (PDL)",
          "grid-connection-types": "monophasé ou triphasé ?",
          "monophase-grid-connection": "monophasé",
          "triphase-grid-connection": "triphasé",

          "meter-container-sizes": "largeur du coffret",
        },
        confirm: {
          title: "Envoyez vos informations",
          "paragraph-1":
            "Confirmez que vous êtes d'accord pour soumettre toutes les informations saisies. Nous commencerons alors à compléter vos services pour vous.</br>",
        },
      },

      errors: {
        "token-invalid": "L'accès est invalide",
        "token-missing": "L'accès est invalide",
      },
    },
  },

  support: {
    home: {
      title: "Get in touch with our team",
      subtitle:
        "Select a category to email the support team or contact us directly by using the form below.",
      "get-in-touch": "Prendre contact",
      "support-card": {
        "start-solar-autonomy": {
          name: "Démarrer autonomie solaire",
          description:
            "Envie de bénéficier d'un conseil pro bono ? Prenez contact avec notre conseil indépendant pour particuliers.",
        },
        "for-industry-farmers": {
          name: "Pour industriels & agriculteurs",
          description:
            "Vous portez un projet solaire de grande puissance ? Prenez contact avec notre équipe au service des installateurs photovoltaïques.",
        },
        "for-photovoltaic-professionals": {
          name: "Pour artisans photovoltaïques",
          description:
            "Besoin de précisions sur nos solutions informatiques ? Prenez contact avec notre équipe technico-administrative pour professionnels.",
        },
        "technical-support": {
          name: "Support technique",
          description:
            "Besoin d'aide sur dépannage technique sur votre compte ? Prenez contact avec notre équipe informatique.",
        },
        "solar-partnerships": {
          name: "Partenariats solaires",
          description:
            "Vous recherchez des solutions informatiques pour le domaine photovoltaïque ? Prenez contact pour des opportunitées de partenariat.",
        },
        press: {
          name: "Presse",
          description:
            "Besoin de nous joindre ? Prenez contact avec notre relation presse.",
        },
      },
    },
    "our-office": {
      title: "Come visit us at our office!",
      subtitle:
        "Located in the Old Port of Marseille, we chose a headquarters in an old art workshop, next to the Memorial of La Marseillaise, to contribute to the regeneration of the neighborhood.",
      location: {
        region: "Provence",
        address: "11 rue Thubaneau, 13001 Marseille, France"
      },
      maps: "Show in Maps"
    },

    "help-center": {
      title: "Explore our help centre for more information",
      subtitle:
        "We have alot of guides that may be useful in helping resolving your question",
    },
    schedule: {
      "chat-online": "Vous préférez discuter directement avec nous en ligne ?",
      "open-chatbox": "Ouvrir messagerie.",
      residential: {
        heading: "Pour particuliers",
        description:
          "Envie de bénéficier d'un conseil pro bono ? Prenez contact avec notre conseil indépendant pour particuliers.",
        breadcrumb: {
          name: "Démarrer son autonomie solaire",
        },
      },
      business: {
        heading: "Pour industriels & agriculteurs",
        description:
          "Vous portez un projet solaire de grande puissance ? Prenez contact avec notre équipe au service des installateurs photovoltaïques.",
        breadcrumb: {
          name: "Pour industriels & agriculteurs",
        },
      },
      installer: {
        heading: "Pour installateurs photovoltaïques",
        description:
          "Besoin de précisions sur nos solutions informatiques ? Prenez contact avec notre équipe technico-administrative pour professionnels.",
        breadcrumb: {
          name: "Pour installateurs photovoltaïques",
        },
      },
      "technical-support": {
        heading: "Support technique",
        description:
          "Besoin d'aide sur dépannage technique sur votre compte ? Prenez contact avec notre équipe informatique.",
        breadcrumb: {
          name: "Support technique",
        },
      },
      partnerships: {
        heading: "Partenariats solaires",
        description:
          "Vous recherchez des solutions informatiques pour le domaine photovoltaïque ? Prenez contact pour des opportunitées de partenariat.",
        breadcrumb: {
          name: "Partenariats solaires",
        },
      },
      press: {
        heading: "Presse",
        description:
          "Besoin de nous joindre ? Prenez contact avec notre relation presse.",
        breadcrumb: {
          name: "Presse",
        },
      },
    },
  },
  help: {
    header: {
      title: "Help Centre",
    },
    home: {
      search: {
        title: "Hi! How can we help?",
        subtitle:
          "Start building for free, then add a site plan to go live. Account plans unlock additional features.",
        placeholder: "Search guides",
      },
      householder: "I am a household",
      installer: "I am an installer",
    },
    householder: {
      title: "Tous les sujets",
      subtitle: "Parcourez notre bibliothèque complète de rubriques d'aide.",
      guides: {
        "your-internet-portal": {
          title: "Votre portail internet",
          description:
            "Instructions faciles à suivre pour créer un compte et gérer son espace en ligne.",
        },
        "payments-pricing-and-refunds": {
          title: "Paiements, tarification et remboursements",
          description:
            "Marche à suivre pour percevoir pleinement son gain économique, comparer les prix euro-watts-crête, régler l’acompte et le solde, et télécharger les factures et reçus.",
        },
        "choose-your-solar-system": {
          title: "Choisir son système solaire",
          description:
            "Comment bénéficier d’une étude de votre pourcentage d’autonomie électrique, et donc de vos économies, par rapport à différentes alternatives de votre projet solaire.",
        },
        "choosing-a-customised-quote": {
          title: "Choisir son devis sur-mesure",
          description:
            "Comment sélectionner parmi plusieurs propositions complètes, détaillés et sur-mesure d’installateurs photovoltaïques proches de chez vous.",
        },
        "validate-feasibility": {
          title: "Valider la faisabilité",
          description:
            "Comment planifier puis se préparer pour la rencontre avec le technicien, et se faire réaliser la faisabilité technique  chez vous du cahier des charges.",
        },
        "investing-in-solar": {
          title: "Investir dans le solaire",
          description:
            "Comment contrôler les assurances et certifications du maitre d’œuvre, signer électroniquement son devis définitif, et régler l’acompte en toute sécurité.",
        },
        "carrying-out-administrative-procedures": {
          title: "Réalisation des démarches administratives",
          description:
            "Comment suivre l’obtention de l’autorisation de l’urbanisme auprès de la mairie, puis planifier l’installation photovoltaïque.",
        },
        "installation-and-commissioning": {
          title: "Pose & mise en service",
          description:
            "Comment valoriser l’injection du surplus avec un raccordement au réseau électrique respectant les normes en vigueur.",
        },
        "legal-notices": {
          title: "Mentions juridiques",
          description:
            "Informations sur la relation contractuelle entre nous et le professionnel photovoltaïque, avec aperçu des conditions générales.",
        },
      },
      cta: {
        title: "Discover others solar journey",
        subtitle:
          "Quasi est quaerat. Sit molestiae et. Provident ad dolorem occaecati eos iste. Soluta rerum quidem minus ut molestiae velit error quod. Excepturi quidem expedita molestias quas.",
        description:
          "Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui lorem cupidatat commodo. Elit sunt amet fugiat veniam occaecat fugiat. Quasi aperiam sit non sit neque reprehenderit.",
        button: "Join our team",
      },
    },
    installer: {
      title: "Tous les sujets",
      subtitle: "Tous les sujets",
      guides: {
        "your-online-account": {
          title: "Votre compte en ligne",
          description:
            "Instructions faciles à suivre pour créer un compte et gérer son espace professionnel.",
        },
        "your-solar-projects": {
          title: "Vos projets solaires",
          description:
            "Instructions simples à suivre pour la gestion et le suivi de prospects, devis, dossiers puis chantiers photovoltaïques sur une seule interface en ligne.",
        },
        "online-photovoltaic-studies": {
          title: "Études photovoltaïques en ligne",
          description:
            "Tout savoir sur comment mieux vendre avec nos présentations personnalisables, vos propositions sur-mesure de systèmes solaires, et notre méthode technico-financière.",
        },
        "dematerialised-administrative-management": {
          title: "Gestion administrative automatisée",
          description:
            "Tout savoir sur comment gagner du temps avec nos services numériques d’envoi et de suivi des démarches administratives obligatoires pour installations photovoltaïques.",
        },
        "contact-and-quotation-proposals": {
          title: "Discover new clients",
          description:
            "Tout savoir sur les signatures électroniques, les paiements automatiques sur internet, la mise en conformité, le service d’assistance de maîtrise d’ouvrage, et bien plus encore. ",
        },
        "materials-planning": {
          title: "Planification du matériel",
          description:
            "Tout savoir sur les listes de matériel de l’entreprise, kits personnalisables, approvisionnement et gestion du stock, comptes rendus de chantiers, et bien plus encore.",
        },
        "after-sales-service": {
          title: "Service après-installation",
          description:
            "Tout savoir sur la responsabilité de chacun, communication entre le maitre d’ouvrage et le maitre d’œuvre, l’entretien, le suivi de rendements, le dépannage et le nettoyage.",
        },
        "payments-pricing-and-refunds": {
          title: "Paiements, tarification et remboursements",
          description:
            "Marche à suivre pour percevoir de l’argent, gagner du chiffre d’affaires, acheter au travers de la boutique en ligne, et télécharger les factures comptables.",
        },
        "legal-notices": {
          title: "Mentions juridiques",
          description:
            "Informations sur la relation contractuelle entre nous et le professionnel photovoltaïque, avec aperçu des conditions générales mentions légales.",
        },
      },
      cta: {
        title: "Join our platform",
        description:
          "Lorem ipsum dolor sit amet consect adipisicing elit. Possimus magnam voluptatum cupiditate veritatis in accusamus quisquam.",
        benefit: {
          benefit1: "Competitive salaries",
          benefit2: "Flexible work hours",
          benefit3: "30 days of paid vacation",
          benefit4: "Annual team retreats",
          benefit5: "Benefits for you and your family",
          benefit6: "A great work environment",
        },
        button: "Sign up now",
      },
    },
    "side-bar": {
      "bread-crumb": {
        help: "Help",
      },
      search: "Search",
      "for-anything": "for anything",
      placeholder: "...",
    },
  },

  common: {
    loading: "Loading...",
    processing: "Chargement...",
    warning: "Alerte !",
    copyright: "2023 © projetsolaire.com. All rights reserved.",
    name: "Name",
    "enter-your-name": "Enter your name",
    email: "Email",
    "enter-your-email": "Enter your email address",
    "your-email": "Your email",
    password: "Password",
    "enter-your-password": "Enter your password",
    siret: "Votre numéro SIRET",
    "enter-your-siret": "Entrez votre SIRET",
    "phone-number": "Votre numéro de téléphone",
    "enter-your-phone-number": "Entrez votre numéro de téléphone",
    "sign-up": "Sign Up",
    "sign-in": "Sign in",
    or: "Ou",
    apply: "Apply",
    optional: "Optional",
    "select-a-tab": "Select a tab",
    title: {
      mr: "Mr",
      mrs: "Mrs",
    },
    "not-signed-in": {
      title: "Not logged in",
      description: "Sorry, to access this content you need to be logged in",
      button: "Sign in now",
    },
    "cookie-gdpr": {
      "cookie-text-1":
        "Nous utilisons les cookies pour mettre nos services à votre disposition.",
      "cookie-text-2": "Pour en savoir, veuillez explorer notre ",
      "cookie-link": "Déclaration de Confidentialité",
      accept: "Accepter",
      decline: "Refuser",
    },
    "algolia-search-dialog": {
      search: "Search",
      placeholder: "Search Anything...",
      results: "Results",
      tags: {
        installer: "Installer",
        householder: "Householder",
        "help-center": "Help center",
        blog: "Blog",
      },
    },
    verifying: {
      title: "Verifying",
      title2: "Verifying that its you",
      description: "We are verifying your access, please bear with us",
    },
    error: {
      title: "Oops there was a problem",
      button: "Go back home",
    },
    success: {
      "confirmed-account": "Successfully confirmed your account",
      "sign-in": "Sign in now",
      "reset-password": "Successfully reset password",
      continue: "Continue",
    },
    "page-not-found": {
      title: "This page does not exist.",
      description: "The page you are looking for could not be found.",
      "go-home": "Go back home",
    },
    "newsletter-dialog": {
      title: "Signup to our newsletter",
      description:
        "We send out some new content each month updating you on the latest news with our mission",
      form: {
        "first-name": "First name",
        "last-name": "Last name",
        company: "Company",
        email: "Email",
      },
      "agree-to-policies": "Agree to policies",
      "switch-agree": "By selecting this, you agree to our",
      "privacy-policy": "privacy policy",
      subscribe: "Subscribe",
    },
    month: {
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December",
    },
    pagination: {
      showing: "Affiche",
      to: "à",
      of: "de",
      results: "résultats",
      previous: "Précédent",
      next: "Suivant",
      related: "Related",
    },
  },

  snackbars: {
    "lead-submitted": "Nous avons reçu votre demande",
    "password-reset-success": "votre mot de passe a été mis à jour.",
    "reset-token-sent":
      "Vérifiez votre boîte mail pour mettre à jour votre mot de passe.",
    "register-success":
      "Vous avez créé votre compte projetsolaire ! Confirmez votre inscription avec le courriel dans votre boîte mail.",
    "login-success": "Bienvenue sur projetsolaire",
    errors: {
      common:
        "Une erreur s’est produite. Veuillez réessayer puis nous contacter si le problème persiste.",
      "password-reset-failed": "La mise à jour du mot de passe a échouée.",
      "login-failed":
        "Connexion échouée : vérifier votre saisie puis réessayer.",
      "register-failed":
        "Nous n’avons pas pu créer votre compte. Veuillez réessayer puis nous contacter si le problème persiste.",
    },
  },
}
